import { createFileRoute } from "@tanstack/react-router";
import { LocationPage, locationImages, locationJsonLd } from "@/components/LocationPage";

export const config = {
  slug: "agra",
  tagline:
    "Healic Hospital Agra on Bodla Road — a trusted multispecialty centre for Shahganj, Sikandra, Bichpuri and greater Agra families.",
  hours: "24*7 Open\u00a0",
  highlights: [
    "Maternity-friendly OPD and labour rooms",
    "Senior gynae, surgery & ENT consultants",
    "Affordable normal & C-section delivery packages",
    "Easy access from Shahganj, Sikandra & NH-19",
  ],
  faqs: [
    { q: "Do you offer normal and C-section deliveries?", a: "Yes, our gynae team handles antenatal care, normal deliveries and C-sections with fixed-price packages." },
    { q: "Where exactly is the Agra hospital?", a: "Plot No-1A, Mauja Bhogipura, Bodla Road, Maruti Estate, New Shahganj, Agra — 282012." },
    { q: "Is ENT surgery available?", a: "Yes — tonsillectomy, FESS sinus surgery and septoplasty are performed regularly." },
    { q: "Which areas does this branch serve?", a: "Shahganj, Bodla, Sikandra, Bichpuri, Bypass Road and nearby Agra." },
  ],
};

export const Route = createFileRoute("/locations/agra")({
  head: () => ({
    meta: [
      { title: "Healic Hospital Agra — Maternity, Surgery & ENT" },
      { name: "description", content: "Healic Hospital Agra at Bodla Road — gynae, surgery, ENT, diagnostics and 7 Am to 12 Am emergency for Shahganj & Sikandra." },
      { property: "og:title", content: "Healic Multispeciality Hospital Agra" },
      { property: "og:description", content: "Trusted multispecialty hospital in Agra — maternity, surgery, ENT and 7 Am to 12 Am ER." },
      { property: "og:url", content: "https://healic.in/locations/agra" },
      { property: "og:image", content: locationImages["agra"] },
    ],
    links: [{ rel: "canonical", href: "https://healic.in/locations/agra" }],
    scripts: locationJsonLd(config),
  }),
  component: () => <LocationPage config={config} />,
});
